import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import _ from 'lodash/fp';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import RouteCollection from '@bd/bdcore-named-routes';
import { Slugify, SanitizeHtml } from '@bd/bdcore-utilities';
import DocumentsMenu from './DocumentsMenu';
import { colors } from '../../styles';

const styles = css`
  .DocumentSection_activeCategoryTitle {
    font-size: 26px;
    line-height: 30px;
    border-bottom: 1px solid ${colors.color4Lightest};
    padding-bottom: 10px;
    margin-bottom: 15px;
    width: 80%;
  }
  .DocumentSection_fileName {
    font-size: 18px;
    line-height: 22px;
  }
  .DocumentSection_subCategoryTitle {
    font-size: 22px;
    line-height: 24px;
    border-bottom: 1px solid ${colors.color4Lightest};
    padding-bottom: 10px;
    margin-bottom: 15px;
    width: 80%;
  }
`;


function DocumentSection({ page, router }) {
  const route = RouteCollection.getRouteByPath(_.get('location.pathname', router));
  const fileSlug = _.get('params.files', route);
  let activeCategory;
  let files = [];

  if (fileSlug) {
    activeCategory = _.getOr([], 'files', page)
      .find(g => Slugify(_.getOr('', 'category_title', g)) === fileSlug);
    files = _.getOr([], 'file_list', activeCategory);
  } else {
    files = _.flow(
      _.map('file_list'),
      _.flatten,
    )(_.getOr([], 'files', page));
  }

  return (
    <div className={styles}>
      <div className="">
        <div className="DocumentSection_builderInformationWrapper pb-3">
          <div className="" dangerouslySetInnerHTML={SanitizeHtml(get(page, 'body_copy'))} />
        </div>
        <div className="DocumentSection_documentListWrapper">
          <DocumentsMenu page={page} />
          {
          activeCategory && activeCategory !== 'undefined' &&
            <div>
              <h3 className="DocumentSection_activeCategoryTitle">{activeCategory.category_title}</h3>
              <ul className="list-unstyled">
                {
                  files.map(item => (
                    <li key={item.file_name}>
                      <a href={item.file.contentUrl} target="_blank" rel="naopener noreferrer">
                        <h5 className="DocumentSection_fileName">{item.file_name}</h5>
                      </a>
                    </li>
                  ))
                }
              </ul>
            </div>
          }
          {
            !activeCategory &&
              <div className="">
                {
                  get(page, 'files', []).map(list => (
                    <div className="mb-3 mb-lg-5" key={list._id}>
                      <h5 className="DocumentSection_subCategoryTitle">{list.category_title}</h5>
                      <ul className="list-unstyled">
                        {
                          get(list, 'file_list', []).map(items => (
                            <li key={items.file_name}>
                              <a
                                href={items.file.contentUrl}
                                target="_blank"
                                rel="naopener noreferrer"
                              >
                                <h5 className="DocumentSection_fileName">{items.file_name}</h5>
                              </a>
                            </li>
                          ))
                        }
                      </ul>
                    </div>
                  ))
                }
              </div>
            }
        </div>
      </div>
    </div>
  );
}

DocumentSection.propTypes = {
  page: PropTypes.object.isRequired,
  router: PropTypes.object.isRequired,
};

export default withData({
  router: true,
})(DocumentSection);



// WEBPACK FOOTER //
// ./src/pages/HOARequest/DocumentSection.js